
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.645 9.109h-4.201a.409.409 0 00-.374.245l-.949 2.132c-.195.44-.63.725-1.11.73h-.013a1.227 1.227 0 01-1.11-.71L8.17 7.831a.205.205 0 00-.356-.027l-.506.76a1.227 1.227 0 01-1.022.547H1.991a.205.205 0 00-.146.347l7.364 7.579a.856.856 0 001.227 0l7.364-7.58a.204.204 0 00-.147-.346l-.008-.003z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M19.114 3.408a4.985 4.985 0 00-7.93-1.27l-1.09.995a.409.409 0 01-.552 0l-1.09-.994a4.985 4.985 0 00-7.93 1.27 4.827 4.827 0 00-.247 3.79.41.41 0 00.385.275h5.192a.41.41 0 00.34-.182l.87-1.305a1.227 1.227 0 012.134.161L10.8 9.592a.205.205 0 00.372 0L11.79 8.2a1.227 1.227 0 011.121-.728h6.064c.173 0 .328-.11.386-.274a4.827 4.827 0 00-.246-3.79z","fill":"currentColor"}})])
          )
        }
      }
    